var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list",class:[
        _vm.direction === 'column' ? 'list_column' : '',
        {'list_wrap' : _vm.wrap}, _vm.customClass
    ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }